import React from 'react'
import ButtonBase from './ButtonBase'

export interface ButtonGradientProps {
  children: React.ReactNode
  disabled?: boolean
  onClick?: () => void
  className?: string
  fullWidth?: boolean
  icon?: React.ReactNode
  iconPosition?: 'left' | 'right'
  'data-testid'?: string
}

const ButtonGradient: React.FC<ButtonGradientProps> = ({
  children,
  disabled = false,
  onClick,
  className = '',
  fullWidth = false,
  icon,
  iconPosition = 'left',
  'data-testid': dataTestId
}) => {
  const iconElement = icon && <span className="flex items-center justify-center">{icon}</span>

  return (
    <ButtonBase
      data-testid={dataTestId}
      disabled={disabled}
      onClick={onClick}
      fullWidth={fullWidth}
      className={`
        !bg-gradient-white-secondary hover:!bg-gradient-white-secondary-hover
        text-off-black focus:ring-sun/20 
        disabled:opacity-50 disabled:cursor-not-allowed 
        border-[1.4px] border-sun disabled:border-white-30
        flex items-center justify-center transition-all duration-200
        ${className}
      `}
    >
      {iconPosition === 'left' && iconElement}
      {iconPosition === 'left' && icon && <span className="ml-2">{children}</span>}
      {!icon && children}
      {iconPosition === 'right' && icon && <span className="mr-2">{children}</span>}
      {iconPosition === 'right' && iconElement}
    </ButtonBase>
  )
}

export default ButtonGradient
